import WOW from 'wowjs';

export const initAnimations = () => {
  // Initialize WOW.js for scroll animations
  if (typeof window !== 'undefined') {
    new WOW.WOW({
      boxClass: 'wow',
      animateClass: 'animated',
      offset: 0,
      mobile: true,
      live: true
    }).init();
  }
};